<template>
  <q-dialog
    ref="dialog"
    class="file-wrap"
    @hide="onDialogHide"
  >
    <q-card
      flat
      class="absolute-top-right z-top q-ma-xs close-btn"
      :class="{
        'fullscreen-document-safe-btn-top': isNativeIos,
      }"
    >
      <q-btn
        flat
        round
        dense
        icon="close"
        class="cursor-pointer"
        @click="hide"
      />
    </q-card>
    <div
      v-if="fileType.includes('image/')"
      class="file-container"
    >
      <q-img
        ref="image"
        :src="fileUrl"
        class="image-container"
        @load="onLoadImage"
      />
    </div>
    <div
      v-else-if="fileType.includes('video/')"
      class="file-container zoom-overlay"
    >
      <video
        :src="fileUrl"
        controls
        class="video-container"
      />
    </div>
    <div
      v-else
      class="file-container"
    >
      <pdf-viewer
        ref="pdfdoc"
        :pdf-src="fileUrl"
        :current-page="pdfPage"
        :show-pagination="false"
        @loaded="onLoadPdf"
      />
    </div>
    <q-inner-loading
      :showing="onOverlay"
      class="zoom-overlay"
      size="0px"
      :label="$t('common.modals.previewFile.mousewheelZoom', {key: 'CTRL'})"
    />
  </q-dialog>
</template>
<script>
import Panzoom from '@panzoom/panzoom';
import PdfViewer from 'components/UI/PdfViewer.vue';

export default {
  name: 'FullscreenDocument',

  components: { PdfViewer },

  props: {
    fileType: {
      type: String,
      required: true,
    },
    fileUrl: {
      type: String,
      required: true,
    },
    pdfPage: {
      type: Number,
      default: null,
    },
  },

  emits: ['hide'],

  data() {
    return {
      panZoomElement: null,
      onOverlay: false,
    };
  },

  computed: {
    isNativeIos() {
      return this.$q.platform.is.capacitor && this.$q.platform.is.ios;
    }, // isNativeIos()
  },

  methods: {
    onLoadPdf() {
      this.panZoomElement = Panzoom(this.$refs.pdfdoc.$refs.pdfViewer.$el, {
        contain: 'outside',
      });
      this.$refs.pdfdoc.$refs.pdfViewer.$el.addEventListener('wheel', this.onMousewheelZoom, { passive: false });
    }, // onLoadPdf()

    onLoadImage() {
      this.panZoomElement = Panzoom(this.$refs.image.$el, {
        contain: 'outside',
      });
      this.$refs.image.$el.addEventListener('wheel', this.onMousewheelZoom, { passive: false });
    }, // onLoadImage()

    onMousewheelZoom(evt) {
      if (!evt.ctrlKey) {
        this.onOverlay = true;
        setTimeout(() => {
          this.onOverlay = false;
        }, 800);
        return;
      }
      evt.preventDefault();
      this.panZoomElement.zoomWithWheel(evt);
    }, // onMousewheelZoom()

    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      if (this.$refs.pdfdoc?.$refs.pdfViewer) {
        this.$refs.pdfdoc.$refs.pdfViewer.$el.removeEventListener('wheel', this.onMousewheelZoom);
      }

      if (this.$refs.image) {
        this.$refs.image.$el.removeEventListener('wheel', this.onMousewheelZoom);
      }

      this.$refs.dialog.hide();
    }, // hide()

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()
  },
};
</script>
<style lang="scss" scoped>
  .file-wrap {
    .close-btn {
      border-radius: 50%;
    }

    :deep(.q-dialog__backdrop) {
      background: rgba(0, 0, 0, 1);
    }
    :deep(.q-dialog__inner--minimized) {
      padding: 0;
      div {
        max-height: inherit;
      }
    }

    .fullscreen-document-safe-btn-top {
      top: env(safe-area-inset-top);
    }
  }
  .file-container {
    width: 100%;
    display: table;
    overflow: auto !important;
  }
  .video-container {
    width: 100%;
    height: 100%;
  }
  .image-container {
    display: table-row;
    max-width: inherit;
    background-color: rgb(255, 255, 255);
  }
  .zoom-overlay {
    max-width: inherit;
    max-height: inherit;
  }
</style>
